import { TagsInput } from '@mantine/core';
import classNames from 'classnames';
import React from 'react';
import { ValidatingFeedback, ValidatingFormContext } from '../validatingElements';

interface IValidatingFormInputTagsProps {
    placeholder?: string;
    name: string;
    icon?: string;
    topLabel?: string;
}

export function ValidatingFormInputTags(props: IValidatingFormInputTagsProps) {
    const classValue = classNames({
        field: true,
        'prepend-icon': props.icon,
        mt5: props.topLabel,
    });

    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <>
                    {props.topLabel && <span className="ml5">{props.topLabel}</span>}
                    <label htmlFor={props.name} className={state.errors.get(props.name) ? `state-error ${classValue}` : classValue}>
                        <TagsInput
                            data={[]}
                            value={state.item[props.name]?.map((v: { value: string }) => v.value) ?? []}
                            onChange={async (value) => {
                                await state.onChange(props.name, value?.map((v: string) => ({ value: v })) ?? []);
                            }}
                        />

                        {props.icon && (
                            <label htmlFor={props.name} className="field-icon">
                                <i className={props.icon}></i>
                            </label>
                        )}
                    </label>
                    <ValidatingFeedback error={state.errors.get(props.name)} />
                </>
            )}
        </ValidatingFormContext.Consumer>
    );
}
